/* eslint-disable eag/match-named-export */
import {z} from '@hono/zod-openapi';

export const sendEventAsPublicUserParams = z.object({
  conversationId: z.string().uuid().openapi({
    description: 'ID of the conversation',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export type SendEventAsPublicUserParams = z.infer<typeof sendEventAsPublicUserParams>;

export const sendEventAsPublicUserBody = z.object({
  content: z.string().min(1).max(2000).openapi({
    description: 'Event content (1-2000 characters)',
    example: 'Hello, I need help with my order.',
  }),
});
